module.exports = __webpack_public_path__ + "img/mobile-17.98ba9c5e.png";